import React from 'react';
import moment from 'jalali-moment';
import CustomLineChart from 'components/charts/lineChart';
import DotsLoading from 'components/loadings/dotsLoading';
import useGetSaleChart from './hooks/useGetSaleChart';
interface SaleChartProps {
  guid: string;
  app: 'farm' | 'wholesaler';
}
const SaleChart = ({app, guid}: SaleChartProps) => {
  const {postChartData, isLoading} = useGetSaleChart(guid);

  return (
    <div className="w-full flex flex-col gap-4">
      <h4 className="flex items-center gap-2 text-gray-6 text-[16px] font-normal">
        <span className="w-2 h-2 flex rounded-full bg-primary" />
        روند کاهش قیمت
      </h4>

      {isLoading ? (
        <>
          <DotsLoading />
        </>
      ) : (
        <>
          <CustomLineChart
            data={{
              labels: postChartData?.map(item =>
                moment(item.date_time).format('jYYYY/jMM/jDD'),
              ),
              datasets: [
                {
                  data: postChartData?.map(item => item.price),
                  borderColor: app === 'farm' ? '#F29E4C' : '#38B3B5',
                  fill: false,
                },
              ],
            }}
          />
        </>
      )}
    </div>
  );
};

export default SaleChart;
